import axios from "axios";
import { telemetry } from "@/telemetry";
import type { DependencyCall } from "@/telemetry";
import { getApiErrorMessage } from "./getApiErrorMessage";
import type { ApiErrorResponse } from "./hooks/types";

export const trackApiError = (
  error: unknown,
  { method, endpoint, durationMs }: Omit<DependencyCall, "status">,
) => {
  const apiError = axios.isAxiosError<ApiErrorResponse>(error)
    ? error
    : undefined;
  const status = apiError?.response?.status;

  telemetry.trackDependency({ method, endpoint, status, durationMs });
  telemetry.trackEvent("api_error", {
    endpoint,
    method,
    status,
    message: getApiErrorMessage(apiError),
    duration_ms: durationMs,
  });

  if (status === 429) telemetry.trackEvent("rate_limited", { endpoint });
  if (status === 422) telemetry.trackEvent("captcha_rejected", { endpoint });
};
